
import { Component, Prop, Vue } from "vue-property-decorator";
import BackgroundLoader from "@/components/Common/BackgroundLoader.vue";
import PhotoPlayer from "@/components/Common/PhotoPlayer.vue";

@Component({
  components: {
    BackgroundLoader,
    PhotoPlayer,
  }
})
export default class IngenieriaItem extends Vue {

  @Prop() source!: string|null;
  @Prop() folder!: string|null;
  @Prop() texto!: string|null;
  @Prop({ default: 0 }) index!: number;

  frames: HTMLImageElement[] = [];
  showPhotos = false;

  created() {
    this.loadFrames();
  }
  mounted() {
    // console.log("IngenieriaItem mounted")
    // console.log("key: ", this.$vnode?.data?.key as string)
    this.showPhotos = false;
  }

  get bgKey() {
    return "bg"+this.index;
  }

  zeroPad = (num: number, places: number) => String(num).padStart(places, "0");
  loadFrames() {
    for (var i = 0; i < this.numFrames[this.index]; i++) {
      this.frames[i] = new Image();
      let img_name = this.zeroPad(i + 1, 2) + ".jpg";
      this.frames[i].src = require("@/assets/fotos/" + this.subfolderName[this.index] + "/" + img_name);
    }
  }

  clase = ['texto-lineales', 'texto-urba', 'texto-hidra', 'texto-indus', 'texto-depor', 'texto-estru', 'texto-geo', 'texto-parques'];

  posButtonY = ['542', '466', '585', '585', null, '662', null, '684'];
  
  numFrames = [4, 59, 4, 2, 0, 2, 0, 3];

  subfolderName = [
      "02_01_ingenieria_lineales",
      "02_02_ingenieria_urbanizacion",
      "02_03_ingenieria_hidraulicas",
      "02_04_ingenieria_industriales",
      "",
      "02_06_ingenieria_estructuras",
      "",
      "02_08_ingeninieria_parques",
  ];

}

